/* ===================================================================
   useReactivationEnroll() -- enroll a CSV of PAST customers into the
   reactivation playbook (Track B: 2 SMS + 1 email cadence). Brad, 2026-07-06.

   POST /api/v1/customers/reactivation-enroll. HARD-GATED on the consent
   attestation server-side: without consent_attested:true the server returns
   403 and creates nothing. On success the server has created consent-stamped
   past_customer_import transactions (which the RequestAgent's Track B cadence
   consumes) plus a per-upload audit row for the 4-year retention rule.

   SMS is system-gated OFF until Twilio A2P is approved -- the response's
   channel_scope / sms_enabled report the real server-side gate, not copy.

   After a successful enroll we invalidate the customers query so counts
   refresh. Fires ONLY on an explicit click after the attestation is ticked.
   =================================================================== */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  api,
  type ReactivationEnrollInput,
  type ReactivationEnrollResult,
} from '../lib/api';
import { qk } from './queryKeys';

export interface UseReactivationEnrollResult {
  enroll: (input: ReactivationEnrollInput) => Promise<ReactivationEnrollResult>;
  isPending: boolean;
  error: Error | null;
}

export function useReactivationEnroll(): UseReactivationEnrollResult {
  const qc = useQueryClient();
  const m = useMutation({
    mutationFn: (input: ReactivationEnrollInput) => api.reactivationEnroll(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: qk.customers() });
    },
  });
  return {
    enroll: (input) => m.mutateAsync(input),
    isPending: m.isPending,
    error: m.error ?? null,
  };
}
